package components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.FormMethod
import org.jetbrains.compose.web.attributes.action
import org.jetbrains.compose.web.attributes.method
import org.jetbrains.compose.web.dom.AttrBuilderContext
import org.jetbrains.compose.web.dom.Form

@Composable
fun TForm(
    attrs: AttrBuilderContext<*> = {},
    content: @Composable () -> Unit = {}
) {
    Form(
        attrs = {
            classes("space-y-6")
            method(FormMethod.Post)
            action("javascript:void(0);")
            attrs()
        }
    ) {
        content()
    }
}